import { STATE_LOGIN, STATE_SIGNUP } from './components/AuthForm'
import { STATE_ADD, STATE_EDIT } from './components/OrganisationForm'
import GAListener from './components/GAListener'
import { EmptyLayout, LayoutRoute, MainLayout, LoadingLayout } from './components/Layout'
import AlertPage from './pages/AlertPage'
import AuthModalPage from './pages/AuthModalPage'
import AuthPage from './pages/AuthPage'
import BadgePage from './pages/BadgePage'
import ButtonGroupPage from './pages/ButtonGroupPage'
import ButtonPage from './pages/ButtonPage'
import CardPage from './pages/CardPage'
import ChartPage from './pages/ChartPage'

// pages
import DashboardPage from './pages/DashboardPage'
import HomePage from './pages/HomePage'
import OrganisationPage from './pages/OrganisationPage'
import UserPage from './pages/UserPage'
import RolePage from './pages/RolePage'
import CreateRolePage from './pages/CreateRolePage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ProfilePage from './pages/ProfilePage'
import CompensationPage from './pages/CompensationPage'
import SetPasswordPage from './pages/SetPasswordPage'
import ConfigurationPage from './pages/ConfigurationPage'
import SitePage from './pages/SitePage'
import SiteThermaPage from './pages/SiteThermaPage'
import CompanyPage from './pages/CompanyPage'
import CompanyUserPage from './pages/CompanyUserPage'
import ActivityPage2 from './pages/ActivityPage2'
import VerifyUserPage from './pages/VerifyUserPage'
import UnsubscribePage from './pages/UnsubscribePage'
import UserCompanyPage from './pages/UserCompanyPage'
import PersonPage from './pages/PersonPage'
import PersonActivityPage from './pages/PersonActivityPage'
import PersonTimesheetPage from './pages/PersonTimesheetPage'
import UserFeaturePage from './pages/UserFeaturePage'
import StoreUserPage from './pages/StoreUserPage'
import CrmUserPage from './pages/CrmUserPage'
import PosLicensingPage from './pages/PosLicensingPage'
import PosLicensingBillingPage from './pages/PosLicensingBillingPage'
import OutstandingLicensingBillingPage from './pages/OutstandingLicensingBillingPage'

import DropdownPage from './pages/DropdownPage'
import FormPage from './pages/FormPage'
import InputGroupPage from './pages/InputGroupPage'
import ModalPage from './pages/ModalPage'
import ProgressPage from './pages/ProgressPage'
import TablePage from './pages/TablePage'
import TypographyPage from './pages/TypographyPage'
import WidgetPage from './pages/WidgetPage'
import React from 'react'
import componentQueries from 'react-component-queries'
import { BrowserRouter, Redirect, Switch } from 'react-router-dom'
import './styles/reduction.scss'
import OrganisationDetailsPage from '././pages/OrganisationDetailsPage'
import StorageService from './services/StorageService'
//POS
import PosPage from './pages/PosPage'
import PosUserPage from './pages/PosUserPage'
import PosUserGroupDetailPage from './pages/PosUserGroupDetailPage'
import PosStorePage from './pages/PosStorePage'
import PosLoadingPage from './pages/PosLoadingPage'
import PosStoreDetailPage from './pages/PosStoreDetailPage'
import ConfigureEcartPage from './pages/ConfigureEcartPage'
import PosStoreProductDetailPage from './pages/PosStoreProductDetailPage'
import PosStorePriceModificationPage from './pages/PosStorePriceModificationPage'
import PosStoreProductConditionPage from './pages/PosStoreProductConditionPage'
import PosProductPage from './pages/PosProductPage'
import PosSupplierDetailPage from './pages/PosSupplierDetailPage'
import PosProductDetailPage from './pages/PosProductDetailPage'
import PosScheduleDetailPage from './pages/PosScheduleDetailPage'
import PosMembershipDetailPage from './pages/PosMembershipDetailPage'
import PosMembershipMemberPage from './pages/PosMembershipMemberPage'
import PosMembershipMemberDetailPage from './pages/PosMembershipMemberDetailPage'
import PosOrderPage from './pages/PosOrderPage'
import PosOrderStorePage from './pages/PosOrderStorePage'
import PosOrderDetailPage from './pages/PosOrderDetailPage'
import PosOrderContractDetailPage from './pages/PosOrderContractDetailPage'
import PosOrderReorderPage from './pages/PosOrderReorderPage'
import PosReportPage from './pages/PosReportPage'
import PosManagementPage from './pages/PosManagementPage'
import PosAnalyticPage from './pages/PosAnalyticPage'
//POS
//CRM
import CrmPage from './pages/CrmPage'
import CrmCustomerPage from './pages/CrmCustomerPage'
import CrmCustomerDetailPage from './pages/CrmCustomerDetailPage'
import CrmCampaignPage from './pages/CrmCampaignPage'
import CrmCampaignDetailPage from './pages/CrmCampaignDetailPage'
import PosUserGroupProductPage from './pages/PosUserGroupProductPage'
import PosUserProductPage from './pages/PosUserProductPage'
import PosUserGroupPage from './pages/PosUserGroupPage'
//CRM

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`
}

const ProtectedRoute = ({ component: Comp, path, ...rest }) => {
  return StorageService.getSession('user_info') ? (
    <LayoutRoute exact layout={MainLayout} component={Comp} path={path} {...rest} />
  ) : (
    <Redirect
      to={{
        pathname: '/login',
      }}
    />
  )
}

class App extends React.Component {
  checkOrgFeaturePage() {
    let featureName = ''
    const user = StorageService.getSession('user_info')
    const org = StorageService.getSession('selected_org')
    if (user !== null) {
      if (org.Features.length > 0) {
        let isAdmin = user.superUser
        let idx = org.Features.findIndex(el => el.Feature === (isAdmin ? 'Configuration' : 'Personnel'))
        if (idx < 0) {
          let firstFeature = org.Features[0].Feature
          featureName = firstFeature
        } else {
          featureName = isAdmin ? 'Configuration' : 'Personnel'
        }
      }
    }
    return featureName
  }

  checkOrgFeatureUrl() {
    let redirectUrl = '/'
    const user = StorageService.getSession('user_info')
    const org = StorageService.getSession('selected_org')
    if (user !== null) {
      if (org.Features.length > 0) {
        let isAdmin = user.superUser
        let idx = org.Features.findIndex(el => el.Feature === (isAdmin ? 'Configuration' : 'Personnel'))
        if (idx < 0) {
          let firstFeature = org.Features[0].Feature
          if (firstFeature === 'Personnel') {
            redirectUrl = '/person'
          } else if (firstFeature === 'POS') {
            redirectUrl = '/posstore'
          } else if (firstFeature === 'CRM') {
            redirectUrl = '/crmcustomer'
          } else {
            redirectUrl = '/company'
          }
        } else {
          redirectUrl = isAdmin ? '/company' : '/site'
        }
      }
    }
    return redirectUrl
  }

  render() {
    //const { path } = '/roles';
    return (
      <BrowserRouter basename={getBasename()}>
        <GAListener>
          <Switch>
            {/* <ProtectedRoute
              exact
              path="/pos"
              layout={MainLayout}
              component={PosPage}
            /> */}
            <ProtectedRoute exact path="/posuser" layout={MainLayout} component={PosUserPage} />
            <ProtectedRoute exact path="/posuser/posusergroup" layout={MainLayout} component={PosUserGroupPage} />
            <ProtectedRoute exact path="/posuser/products/:id" layout={MainLayout} component={PosUserProductPage} />
            <ProtectedRoute exact path="/posuser/posusergroup/:id" layout={MainLayout} component={PosUserGroupDetailPage} />
            <ProtectedRoute exact path="/posuser/posusergroup/products/:id" layout={MainLayout} component={PosUserGroupProductPage} />
            <ProtectedRoute
              exact
              path="/posstore"
              layout={MainLayout}
              component={props => <PosStorePage {...props} />}
              // component={PosStorePage}
            />
            <ProtectedRoute
              exact
              path="/loading"
              layout={LoadingLayout}
              component={props => <PosLoadingPage {...props} />}
              // component={PosStorePage}
            />
            <ProtectedRoute exact path="/posstore/schedule/:id" layout={MainLayout} component={PosScheduleDetailPage} />
            <ProtectedRoute exact path="/posstore/membership/:id" layout={MainLayout} component={PosMembershipDetailPage} />
            <ProtectedRoute exact path="/posstore/membership/member/:id" layout={MainLayout} component={PosMembershipMemberPage} />
            <ProtectedRoute exact path="/posstore/membership/member/:id/detail/:member_id" layout={MainLayout} component={PosMembershipMemberDetailPage} />
            <ProtectedRoute exact path="/posstore/:id" layout={MainLayout} component={props => <PosStoreDetailPage {...props} />} />
            <ProtectedRoute exact path="/posstore/:id/pricemodification" layout={MainLayout} component={props => <PosStorePriceModificationPage {...props} />} />
            <ProtectedRoute exact path="/posstore/:id/productcondition" layout={MainLayout} component={props => <PosStoreProductConditionPage {...props} />} />
            <ProtectedRoute exact path="/posstore/:id/configureecart" layout={MainLayout} component={props => <ConfigureEcartPage {...props} />} />
            <ProtectedRoute exact path="/posstore/:id/product/:productid" layout={MainLayout} component={props => <PosStoreProductDetailPage {...props} />} />
            <ProtectedRoute exact path="/posproduct" layout={MainLayout} component={props => <PosProductPage {...props} />} />
            <ProtectedRoute exact path="/posproduct/:id" layout={MainLayout} component={props => <PosProductDetailPage {...props} />} />
            <ProtectedRoute exact path="/posproduct/supplier/:id" layout={MainLayout} component={props => <PosSupplierDetailPage {...props} />} />
            <ProtectedRoute exact path="/posorder" layout={MainLayout} component={props => <PosOrderPage {...props} />} />
            <ProtectedRoute exact path="/posorder/store/:id" layout={MainLayout} component={props => <PosOrderStorePage {...props} />} />
            <ProtectedRoute exact path="/posorder/store/:id/:order_id" layout={MainLayout} component={props => <PosOrderDetailPage {...props} />} />
            <ProtectedRoute exact path="/posorder/store/:id/contract/:data_id/:product_id" layout={MainLayout} component={props => <PosOrderContractDetailPage {...props} />} />
            <ProtectedRoute exact path="/posorder/store/:id/reorder/:order_id" layout={MainLayout} component={props => <PosOrderReorderPage {...props} />} />
            <ProtectedRoute exact path="/posreport" layout={MainLayout} component={props => <PosReportPage {...props} />} />
            <ProtectedRoute exact path="/posmanagement" layout={MainLayout} component={props => <PosManagementPage {...props} />} />
            <ProtectedRoute exact path="/posanalytic" layout={MainLayout} component={props => <PosAnalyticPage {...props} />} />
            <ProtectedRoute exact path="/crm" layout={MainLayout} component={CrmPage} />
            <ProtectedRoute exact path="/crmcustomer" layout={MainLayout} component={props => <CrmCustomerPage {...props} />} />
            <ProtectedRoute exact path="/crmcustomer/:id" layout={MainLayout} component={props => <CrmCustomerDetailPage {...props} />} />
            <ProtectedRoute exact path="/crmcampaign" layout={MainLayout} component={props => <CrmCampaignPage {...props} />} />
            <ProtectedRoute exact path="/crmcampaign/:id" layout={MainLayout} component={props => <CrmCampaignDetailPage {...props} />} />

            <LayoutRoute exact path="/verify" layout={EmptyLayout} component={VerifyUserPage} />
            <LayoutRoute exact path="/unsubscribe" layout={EmptyLayout} component={UnsubscribePage} />
            <LayoutRoute exact path="/login" layout={EmptyLayout} component={props => <AuthPage {...props} authState={STATE_LOGIN} />} />
            <LayoutRoute exact path="/signup" layout={EmptyLayout} component={props => <AuthPage {...props} authState={STATE_SIGNUP} />} />
            <LayoutRoute exact path="/forgot-password" layout={EmptyLayout} component={ForgotPasswordPage} />
            <LayoutRoute exact path="/set-password" layout={EmptyLayout} component={SetPasswordPage} />
            <ProtectedRoute exact path="/profile" layout={MainLayout} component={ProfilePage} />
            <ProtectedRoute
              exact
              path="/organisation"
              layout={MainLayout}
              component={props => <OrganisationPage {...props} viewState={STATE_ADD} />}
              //component={OrganisationPage}
            />
            <ProtectedRoute exact path="/organisation/details/:id" layout={MainLayout} component={props => <OrganisationDetailsPage {...props} viewState={STATE_EDIT} />} />
            <ProtectedRoute exact path="/user" layout={MainLayout} component={UserPage} />

            <ProtectedRoute exact path="/licensing" layout={MainLayout} component={PosLicensingPage} />
            <ProtectedRoute exact path="/licensing/:id/billing" layout={MainLayout} component={PosLicensingBillingPage} />
            <ProtectedRoute exact path="/outstanding-billing" layout={MainLayout} component={OutstandingLicensingBillingPage} />

            <ProtectedRoute exact path="/role" layout={MainLayout} component={RolePage} />
            <ProtectedRoute exact path="/roles/create" layout={MainLayout} component={CreateRolePage} />
            <ProtectedRoute exact path="/compensation" layout={MainLayout} component={CompensationPage} />
            <ProtectedRoute exact path="/configuration" layout={MainLayout} component={ConfigurationPage} />
            <ProtectedRoute exact path="/site" layout={MainLayout} component={props => <SitePage {...props} />} />
            <ProtectedRoute exact path="/site/:id/site-therma" layout={MainLayout} component={props => <SiteThermaPage {...props} />} />
            <ProtectedRoute exact path="/site/:id/activity" layout={MainLayout} component={props => <ActivityPage2 {...props} />} />
            <ProtectedRoute exact path="/company" layout={MainLayout} component={props => <CompanyPage {...props} />} />
            <ProtectedRoute exact path="/company-user" layout={MainLayout} component={props => <UserFeaturePage {...props} />} />
            <ProtectedRoute exact path="/store-user" layout={MainLayout} component={props => <StoreUserPage {...props} />} />
            <ProtectedRoute exact path="/crm-user" layout={MainLayout} component={props => <CrmUserPage {...props} />} />
            <ProtectedRoute exact path="/company/:id/user" layout={MainLayout} component={props => <CompanyUserPage {...props} />} />
            <ProtectedRoute exact path="/company-information" layout={MainLayout} component={props => <UserCompanyPage {...props} />} />
            <ProtectedRoute exact path="/person" layout={MainLayout} component={props => <PersonPage {...props} />} />
            <ProtectedRoute exact path="/person/:person/activity" layout={MainLayout} component={props => <PersonActivityPage {...props} />} />
            <ProtectedRoute exact path="/person/:person/timesheet" layout={MainLayout} component={props => <PersonTimesheetPage {...props} />} />
            <ProtectedRoute
              exact
              path={this.checkOrgFeatureUrl()}
              layout={MainLayout}
              component={props =>
                this.checkOrgFeaturePage() === 'Personnel' ? (
                  <SitePage {...props} />
                ) : this.checkOrgFeaturePage() === 'POS' ? (
                  <PosStorePage {...props} />
                ) : this.checkOrgFeaturePage() === 'CRM' ? (
                  <CrmCustomerPage {...props} />
                ) : this.checkOrgFeaturePage() === 'User' ? (
                  <UserFeaturePage {...props} />
                ) : (
                  <CompanyPage {...props} />
                )
              }
            />
            <ProtectedRoute
              exact
              path="/"
              layout={MainLayout}
              component={props =>
                this.checkOrgFeaturePage() === 'Personnel' ? (
                  <SitePage {...props} />
                ) : this.checkOrgFeaturePage() === 'POS' ? (
                  <PosStorePage {...props} />
                ) : this.checkOrgFeaturePage() === 'CRM' ? (
                  <CrmCustomerPage {...props} />
                ) : this.checkOrgFeaturePage() === 'User' ? (
                  <UserFeaturePage {...props} />
                ) : (
                  <CompanyPage {...props} />
                )
              }
            />
            <Redirect to="/" />
          </Switch>
        </GAListener>
      </BrowserRouter>
    )
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' }
  }

  if (576 < width && width < 767) {
    return { breakpoint: 'sm' }
  }

  if (768 < width && width < 991) {
    return { breakpoint: 'md' }
  }

  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' }
  }

  if (width > 1200) {
    return { breakpoint: 'xl' }
  }

  return { breakpoint: 'xs' }
}

export default componentQueries(query)(App)
